import { IState } from '../reducers'

export const getUserGroup = (state: IState): string => state.user.group
export const getUserName = (state: IState): string => state.user.name
export const getUserId = (state: IState): number => state.user.uid
